import script from "./BaseFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFilters.vue?vue&type=script&setup=true&lang=js"

import "./BaseFilters.vue?vue&type=style&index=0&id=135decdc&scoped=true&lang=scss"

import exportComponent from "/Users/acatohw/Development/openwebconcept/app/public_html/wp-content/plugins/openkaarten-frontend-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-135decdc"]])

export default __exports__